import { render, staticRenderFns } from "./ReviewImport.vue?vue&type=template&id=49b06b3d&scoped=true"
import script from "./ReviewImport.vue?vue&type=script&lang=js"
export * from "./ReviewImport.vue?vue&type=script&lang=js"
import style0 from "./ReviewImport.vue?vue&type=style&index=0&id=49b06b3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b06b3d",
  null
  
)

export default component.exports